/* eslint-disable consistent-return */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useRef, useState } from 'react';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useHistory, Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import PDFExportPanel from '../../../../SharedModules/pdfExport/PDFExportPanel';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import ManufacturerTabs from './ManufacturerTabs';
import ManufacturerContact from './ManufacturerContact';
import ManufacturerBankruptcy from './ManufacturerBankruptcy';
import ManufacturerContracts from './ManufacturerContracts';
import ManufacturerLabelers from './ManufacturerLabelers';
import ManufacturerDetails from './ManufacturerDetails';

import { MinDate } from '../../../../SharedModules/CommonConstants/commonConstants';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  convertQuatreManufacturer,
  validDate,
  closeTab,
  handleExistingCommentList,
  getCommonDropdownList,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  BankruptcyHead,
  contractsHead,
  CommercialLabelerHead,
} from './gridComponents/tableHead';
import {
  maintainLabelerListData,
  setSelectManufacturerData,
  addNewRowBankruptcy,
  getContactDetails,
  getAllMFGContractList,
  resetUpdateOrSaveMessage,
  getAllContactType,
  postSaveOrUpdate,
  getGeneralSystemParameterDetails,
  permanentDeleteLabelerRow,
  fetchAllManufacturerDetail,
  setMaintainManufacturerTab,
  deleteLabelersData,
  setNewLabelersListAction,
  setNewBankruptcyListAction,
  getExistingContactDetails,
  getExistingManufactureId,
} from '../store/ManufacturerAction';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

export default function AddEditManufacturer() {
  const dispatch = useDispatch();
  const history = useHistory();
  const addReduxDataUpdateManufacturerTab = (value) =>
    dispatch(setMaintainManufacturerTab(value));
  const fetchAllContractList = (value) =>
    dispatch(getAllMFGContractList(value));
  const getContactDetailsValue = (value) => dispatch(getContactDetails(value));
  const resetUpdateOrSaveMessageHandler = (value) =>
    dispatch(resetUpdateOrSaveMessage(value));
  const saveOrUpdate = (value) => dispatch(postSaveOrUpdate(value));
  const deleteSingleLabeler = (value) =>
    dispatch(permanentDeleteLabelerRow(value));

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const createMFG = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.selectManufacturerData
      .createManufacturer;
  });
  const selectMFGData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.selectManufacturerData;
  });
  const addEditManufacturerTabData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.maintainManufacturerObj;
  });
  const contractListRowData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.contractList;
  });
  const contactDetails = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.contactDetails;
  });
  const labelerRowData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.labelersList;
  });
  const bankruptcyRowData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.bankruptcyList;
  });
  const singleManufacturerDetail = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.manufacturerDetailsList;
  });
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.saveOrUpdateMessage;
  });

  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const existingContactDetails = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.existingContactDetails;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const gridRef = useRef();
  const childRef = useRef(null);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [applyFilter, setApplyFilter] = React.useState(false);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] =
    React.useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);
  const [exportFileName, setExportFileName] = React.useState(
    'Manufacturer-Labelers'
  );
  const [gridApi, setGridApi] = React.useState(gridRef);
  const [callContactDetailApi, setCallContactDetailApi] = React.useState(false);
  const [columnApi, setColumnApi] = React.useState(null);
  const [commentShow, setCommentShow] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [tabValue, setTabValue] = React.useState('one');
  // Baseline Contact form values while Save/Cancel are disabled (clean form).
  // Used by Cancel to restore Contact Type and other contact fields.
  const originalContactDetailRef = React.useRef(null);
  // Tracks which tabs the user has actually modified (made dirty). Validations
  // for a tab are only shown once that tab has been edited - not on mere
  // navigation between tabs.
  const [dirtyTabs, setDirtyTabs] = React.useState({});
  const markCurrentTabDirty = () => {
    setDirtyTabs((prev) =>
      prev[tabValue] ? prev : { ...prev, [tabValue]: true }
    );
  };
  // Wrapper around setDisabledSaveCancelBtn that also records the active tab as
  // dirty whenever the form is marked modified (value === false).
  const handleTabFormDirty = (value) => {
    setDisabledSaveCancelBtn(value);
    if (value === false) {
      markCurrentTabDirty();
    }
  };
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [keyValue, setKeyValue] = React.useState([]);
  const [bankruptcyTypeCd, setBankruptcyTypeCd] = React.useState(null);
  const [startDt, setStartDt] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [spinnerLoader, setSpinnerLoader] = React.useState(false);
  const [totalResultCount, setTotalResultCount] = React.useState(0);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [callUpdateAPI, setCallUpdateAPI] = React.useState(true);
  const [values, setValues] = React.useState({
    mfgId: null,
    mfgName: null,
    mfgTypeCd: selectMFGData.mfgTypeCd,
    corrLinkId: null,
  });
  const [error, setError] = React.useState({
    mfgId_Error: '',
    mfgName_Error: '',
  });

  // default manufacturer detail initial value
  const initializeManufacturerDetail = {
    rebatewebParticipantInd: 0,
    defEnrollmentTimingCd: '-1',
    defWacPct: null,
    defCollectionMediumCd: '-1',
    defPricingTimingCd: '-1',
    defPaperInd: 0,
    defPaperFinalQtr: '',
    defCmsElectInd: 0,
    defCmsElectFinalQtr: '',
    defNcpdpSummaryInd: 0,
    defNcpdpSummaryFinalQtr: '',
    defNcpdpClaimOwnInd: 0,
    defNcpdpClaimOwnFinalQtr: '',
    defNcpdpClaimMbInd: 0,
    defNcpdpClaimMbFinalQtr: '',
    defPrintImageInd: 0,
    defPrintImageFinalQtr: '',
  };
  const [manufacturerDetail, setManufacturerDetail] = React.useState(
    initializeManufacturerDetail
  );
  // default contact details initial value
  const initializeContact = {
    contactSeqNum: null,
    key: null,
    keyTypeCd: 'CMS',
    contactTypeCd: 'CMSINV',
    contactName: '',
    corpName: '',
    addrLine1: '',
    addrLine2: '',
    addrLine3: '',
    city: '',
    stateCd: '',
    zip: '',
    zip4: '',
    phoneNum: '',
    phoneExtension: '',
    faxNum: '',
    email: '',
  };
  const [contactDetail, setContactDetail] = React.useState(initializeContact);
  // Capture Contact baseline whenever the form is clean so Cancel can restore it.
  React.useEffect(() => {
    if (disabledSaveCancelBtn && contactDetail) {
      originalContactDetailRef.current = JSON.parse(
        JSON.stringify(contactDetail)
      );
    }
  }, [disabledSaveCancelBtn, contactDetail]);
  const resetContactBaseline = (contact) => {
    if (contact) {
      originalContactDetailRef.current = JSON.parse(JSON.stringify(contact));
    }
  };
  const [permanentDeleteLabelerList, setPermanentDeleteLabelerList] =
    React.useState([]);
  const [updateBankruptcyList, setUpdateBankruptcyList] = React.useState([]);
  const [permanentDeleteLaBankruptcyList, setPermanentDeleteLaBankruptcyList] =
    React.useState([]);
  const [
    {
      showLabelerStartDateErr,
      showLabelerEndDateErr,
      showNameErr,
      showAddrErr,
      showCityErr,
      showStateErr,
      showZipErr,
      showZip4Err,
      showPhoneErr,
      showEmailErr,
      showDefPaperFinalQTRErr,
      showDefCmsElectFinalQTRErr,
      showDefNcpSummaryFinalQtrErr,
      showDefNcpdpClaimOwnFinalQTRErr,
      showDefNcpdpClaimMbFinalQTRErr,
      showDefPrintImageFinalQtrErr,
      showBankruptcyTypeCdErr,
      showBankruptcyStartDateErr,
      showBankruptcyEndDateErr,
      showBankruptcyOverlappingErr,
    },
    setShowError,
  ] = React.useState(false);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  // check role based access for State and Inquiry State employees
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  // handing refresh functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      addEditManufacturerTabData &&
      Object.keys(addEditManufacturerTabData).length > 0
    ) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/manufacturer-detail' && !disabledSaveCancelBtn) {
            item.isFormDirty = true;
            if (
              addEditManufacturerTabData.errorMessages &&
              addEditManufacturerTabData.errorMessages.length > 0
            ) {
              item.isFormError = true;
            } else {
              item.isFormError = false;
            }
          } else if (item.navTo === '/manufacturer-detail')
            item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [disabledSaveCancelBtn || addEditManufacturerTabData]);
  // handing tab highlight functionality
  React.useEffect(() => {
    if (
      (addEditManufacturerTabData &&
        Object.keys(addEditManufacturerTabData).length === 0) ||
      addEditManufacturerTabData.action === 'update'
    ) {
      setDisabledSaveCancelBtn(true);
      resetUpdateOrSaveMessageHandler('');
      setErrorMessages([]);
      handleScrollToEvent();
      dispatch(getGeneralSystemParameterDetails());
      if (callUpdateAPI) {
        setCallUpdateAPI(false);
        if (!createMFG) {
          fetchAllContractList({
            showAllInd: false,
            mfgId: selectMFGData && selectMFGData.mfgId,
          });
          getContactDetailsValue({
            keyTypeCd: 'CMS',
            key: selectMFGData.mfgId,
            contactTypeCd: 'CMSINV',
          });
          setCallContactDetailApi(true);
          getContactDetailsValue(null);
          dispatch(
            fetchAllManufacturerDetail({
              mfgId: selectMFGData && selectMFGData.mfgId,
            })
          );
          dispatch(
            getExistingContactDetails({
              key: [selectMFGData?.mfgId],
              keyTypeCd: 'MFG',
            })
          );
        } else {
          const newObj = {
            actionVal: 0,
            labelerCode: '',
            labelerName: '',
            startDate: null,
            lastUpdateDt: null,
            endDate: null,
            lastUpdateUserId: null,
            corrLinkId: null,
            mfgId: null,
            mfgTypeCd: 'G',
            isAddedFromUI: null,
            startDateErr: false,
            endDateErr: false,
            ccCommentsExist: 0,
          };
          if (selectMFGData && selectMFGData.mfgTypeCd === 'G') {
            dispatch(maintainLabelerListData(newObj, selectMFGData.mfgTypeCd));
          } else if (labelerRowData && labelerRowData.length > 0)
            dispatch(deleteLabelersData(0, newObj));
        }
      }
    } else {
      const tempObj = addEditManufacturerTabData;
      if (tempObj?.values) {
        setValues(tempObj.values);
      }
      if (tempObj?.disabledSaveCancelBtn)
        setDisabledSaveCancelBtn(tempObj.disabledSaveCancelBtn);
      if (tempObj?.tabValue) setTabValue(tempObj.tabValue);
      if (tempObj?.manufacturerDetail)
        setManufacturerDetail(tempObj.manufacturerDetail);
      if (tempObj?.contactDetail) setContactDetail(tempObj.contactDetail);
      if (tempObj?.fullScreenView) setFullScreenView(tempObj.fullScreenView);
      if (tempObj?.callContactDetailApi)
        setCallContactDetailApi(tempObj?.callContactDetailApi);
      if (tempObj?.permanentDeleteLabelerList)
        setPermanentDeleteLabelerList(tempObj.permanentDeleteLabelerList);
      setErrorMessages(tempObj?.errorMessages);
      if (tempObj?.error) setError(tempObj?.error);
      setShowError({
        showLabelerStartDateErr: tempObj?.showLabelerStartDateErr,
        showLabelerEndDateErr: tempObj?.showLabelerEndDateErr,
        showNameErr: tempObj?.showNameErr,
        showAddrErr: tempObj?.showAddrErr,
        showCityErr: tempObj?.showCityErr,
        showStateErr: tempObj?.showStateErr,
        showZipErr: tempObj?.showZipErr,
        showZip4Err: tempObj?.showZip4Err,
        showPhoneErr: tempObj?.showPhoneErr,
        showEmailErr: tempObj?.showEmailErr,
        showDefPaperFinalQTRErr: tempObj?.showDefPaperFinalQTRErr,
        showDefCmsElectFinalQTRErr: tempObj?.showDefCmsElectFinalQTRErr,
        showDefNcpSummaryFinalQtrErr: tempObj?.showDefNcpSummaryFinalQtrErr,
        showDefNcpdpClaimOwnFinalQTRErr:
          tempObj?.showDefNcpdpClaimOwnFinalQTRErr,
        showDefNcpdpClaimMbFinalQTRErr: tempObj?.showDefNcpdpClaimMbFinalQTRErr,
        showDefPrintImageFinalQtrErr: tempObj?.showDefPrintImageFinalQtrErr,
        showBankruptcyTypeCdErr: tempObj?.showBankruptcyTypeCdErr,
        showBankruptcyStartDateErr: tempObj?.showBankruptcyStartDateErr,
        showBankruptcyEndDateErr: tempObj?.showBankruptcyEndDateErr,
        showBankruptcyOverlappingErr: tempObj?.showBankruptcyOverlappingErr,
      });
    }
  }, [
    Object.keys(singleManufacturerDetail).length > 0 ||
      addEditManufacturerTabData,
  ]);
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: [
        'ENROLLMENT_TIMING_CD',
        'PRICING_TIMING_CD',
        'COLLECTION_MEDIUM_CD',
        'BANKRUPTCY_TYPE_CD',
      ],
    }).then((res) => {
      setCommonDropdownList(res);
    });
    dispatch(
      getAllContactType({
        keyTypeCd:
          selectMFGData && selectMFGData.mfgTypeCd === 'C'
            ? 'COMMFG'
            : 'GOVMFG',
      })
    );
  }, []);
  React.useEffect(() => {
    if (showComments) {
      handleExistingCommentList([{ corrLinkId: values?.corrLinkId }]).then(
        (res) => {
          setCommentShow(res.ccCommentsExist === 1);
        }
      );
    }
  }, [commentsList]);
  React.useEffect(() => {
    if (tabValue === 'one') {
      setExportFileName('Manufacturer-Labelers');
    } else if (tabValue === 'four') {
      setExportFileName('Manufacturer-Bankruptcy');
    } else if (tabValue === 'five') {
      setExportFileName('Manufacturer-Contracts');
    }
  }, []);
  // after call manufacturer save in database
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      if (!clickOncloseTabBtn) {
        closeTab('/manufacturer-detail', history, dispatch);
        saveOrUpdate(null);
      }
      dispatch(setMaintainManufacturerTab({}));
      setSpinnerLoader(false);
      setDisabledSaveCancelBtn(true);
      setDirtyTabs({});
      setCallContactDetailApi(true);
      const obj = { ...selectMFGData };
      obj.mfgId = saveOrUpdateMessage.mfgId;
      obj.createManufacturer = false;
      dispatch(setSelectManufacturerData(obj));
      dispatch(
        fetchAllManufacturerDetail({ mfgId: saveOrUpdateMessage.mfgId })
      );
      dispatch(
        getExistingContactDetails({
          key: [saveOrUpdateMessage.mfgId],
          keyTypeCd: 'MFG',
        })
      );
      addReduxDataUpdateManufacturerTab({
        error: { ...error, mfgName_Error: '' },
        errorMessages: [],
        successMessages: [],
        disabledSaveCancelBtn: false,
        action: 'update',
      });
    } else if (saveOrUpdateMessage === 'failed') {
      setSpinnerLoader(false);
      setErrorMessages([constantMessageData.FAILED_MESSAGE_GENERIC]);
      setSuccessMessage([]);
      addReduxDataUpdateManufacturerTab({
        error: { ...error, mfgName_Error: '' },
        disabledSaveCancelBtn: false,
        errorMessages: [constantMessageData.FAILED_MESSAGE_GENERIC],
        successMessages: [],
        action: 'error',
      });
    }
  }, [saveOrUpdateMessage]);
  // page load call
  // skipContactReset: used by Cancel so Contact Type/fields are restored from
  // originalContactDetailRef instead of a conflicting contact API reload.
  const fetchDataFromServer = (options = {}) => {
    const { skipContactReset = false } = options;
    if (Object.keys(selectMFGData).length > 0) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      // eslint-disable-next-line no-unused-expressions
      updateTabs?.map((item) => {
        if (item.navTo === '/manufacturer-detail') {
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      setPermanentDeleteLabelerList([]);
      setPermanentDeleteLaBankruptcyList([]);
      setErrorMessages([]);
      const labelerData =
        singleManufacturerDetail && singleManufacturerDetail.labelerVO;
      const MFGDetail =
        singleManufacturerDetail && singleManufacturerDetail.mfgVO;
      if (MFGDetail && Object.keys(MFGDetail).length > 0) {
        setSpinnerLoader(false);
        MFGDetail.defEnrollmentTimingCd =
          MFGDetail.defEnrollmentTimingCd == null
            ? '-1'
            : MFGDetail.defEnrollmentTimingCd;
        MFGDetail.defPricingTimingCd =
          MFGDetail.defPricingTimingCd == null
            ? '-1'
            : MFGDetail.defPricingTimingCd;
        MFGDetail.defCollectionMediumCd =
          MFGDetail.defCollectionMediumCd == null
            ? '-1'
            : MFGDetail.defCollectionMediumCd;
        setValues({
          mfgId: MFGDetail && MFGDetail.mfgId,
          mfgName: MFGDetail && MFGDetail.mfgName,
          mfgTypeCd: MFGDetail && MFGDetail.mfgTypeCd,
          corrLinkId: MFGDetail && MFGDetail.corrLinkId,
        });
        setManufacturerDetail(MFGDetail);
        handleExistingCommentList([{ corrLinkId: MFGDetail?.corrLinkId }]).then(
          (res) => {
            setCommentShow(res.ccCommentsExist === 1);
          }
        );
      }
      if (!skipContactReset) {
        const contactVO =
          singleManufacturerDetail && singleManufacturerDetail.contactVO;

        if (contactVO && Object.keys(contactVO).length > 0) {
          const restoredContactTypeCd =
            contactVO.contactTypeCd == null
              ? 'CMSINV'
              : contactVO.contactTypeCd;
          getContactDetailsValue({
            keyTypeCd: 'CMS',
            key: selectMFGData.mfgId,
            contactTypeCd: restoredContactTypeCd,
          });
          setContactDetail({
            ...contactVO,
            contactTypeCd: restoredContactTypeCd,
            zip4: contactVO.zip4 ? String(contactVO.zip4).trim() : '',
            email: contactVO.email ? String(contactVO.email).trim() : '',
            phoneNum: contactVO.phoneNum
              ? String(contactVO.phoneNum).trim()
              : '',
          });
        } else if (existingContactDetails?.length > 0) {
          setContactDetail(existingContactDetails[0]);
        } else {
          setContactDetail(initializeContact);
        }
      }
      const bankruptcyList =
        singleManufacturerDetail && singleManufacturerDetail.mfgBankruptcyVO;
      if (bankruptcyList && bankruptcyList.length > 0) {
        const tempObj = bankruptcyList.map((prop) => {
          prop.ccCommentsExist = 0;
          prop.permanentDelete = true;
          prop.addEditRow = false;
          prop.id = uuidv4();
          prop.isEdit = false;
          prop.actionVal = 1;
          prop.bankruptcyTypeCdErr = false;
          prop.startDateErr = false;
          prop.endDateErr = false;
          prop.mfgBankCruptcyId = prop.mfgBankCruptcyId;
          prop.endDate = prop.endDate ? prop.endDate : '';
          prop.startDate =
            prop.mfgBankCruptcyId && prop.mfgBankCruptcyId.startDate
              ? prop.mfgBankCruptcyId.startDate
              : '';
          prop.bankruptcyTypeCd =
            prop.mfgBankCruptcyId &&
            prop.mfgBankCruptcyId.bankruptcyTypeCd === null
              ? '-1'
              : prop.mfgBankCruptcyId && prop.mfgBankCruptcyId.bankruptcyTypeCd;
          return prop;
        });
        setUpdateBankruptcyList(JSON.parse(JSON.stringify([...tempObj])));
        handleExistingCommentList(
          tempObj,
          dispatch,
          setNewBankruptcyListAction
        );
      } else {
        dispatch(addNewRowBankruptcy({}));
      }

      if (selectMFGData?.mfgTypeCd === 'G') {
        labelerData &&
          labelerData.length > 0 &&
          labelerData.forEach((prop, index) => {
            if (index === 0) {
              handleExistingCommentList([{ corrLinkId: prop.corrLinkId }]).then(
                (res) => {
                  dispatch(
                    maintainLabelerListData(
                      {
                        labelerCode: prop.labelerCode,
                        actionVal: 1,
                        labelerName: prop.labelerName,
                        lastUpdateDt: prop.lastUpdateDt,
                        endDate: prop.endDate ? prop.endDate : '',
                        startDate: prop.lastUpdateDt ? prop.lastUpdateDt : '',
                        lastUpdateUserId: prop.lastUpdateUserId,
                        corrLinkId: prop.corrLinkId,
                        mfgId: selectMFGData && selectMFGData.mfgId,
                        mfgTypeCd: selectMFGData && selectMFGData.mfgTypeCd,
                        permanentDelete: true,
                        startDateErr: false,
                        endDateErr: false,
                        ccCommentsExist: res.ccCommentsExist,
                      },
                      selectMFGData.mfgTypeCd
                    )
                  );
                }
              );
            }
          });
      } else if (labelerData?.length > 0) {
        let tempObj = [];
        tempObj = labelerData?.map((prop) => {
          return {
            labelerCode: prop.labelerCode,
            actionVal: 1,
            labelerName: prop.labelerName,
            lastUpdateDt: prop.lastUpdateDt,
            endDate: prop.endDate ? prop.endDate : '',
            startDate: prop.lastUpdateDt ? prop.lastUpdateDt : '',
            lastUpdateUserId: prop.lastUpdateUserId,
            corrLinkId: prop.corrLinkId,
            mfgId: selectMFGData?.mfgId,
            mfgTypeCd: selectMFGData?.mfgTypeCd,
            permanentDelete: true,
            isEdit: false,
            startDateErr: false,
            endDateErr: false,
            ccCommentsExist: 0,
          };
        });
        handleExistingCommentList(tempObj, dispatch, setNewLabelersListAction);
      } else {
        dispatch(maintainLabelerListData({}));
      }
    }
  };

  React.useEffect(() => {
    if (
      !createMFG &&
      ((addEditManufacturerTabData &&
        Object.keys(addEditManufacturerTabData).length === 0) ||
        addEditManufacturerTabData.action === 'update')
    ) {
      fetchDataFromServer();
    }
  }, [singleManufacturerDetail]);
  // set contact details on page load
  React.useEffect(() => {
    if (contactDetails && contactDetails.length > 0) {
      const tempObj = contactDetails[0];
      tempObj.zip4 =
        (tempObj.zip4 !== null?.zip4) !== undefined ? tempObj.zip4?.trim() : '';
      tempObj.email =
        (tempObj.email !== null?.email) !== undefined
          ? tempObj.email?.trim()
          : '';
      tempObj.phoneNum =
        (tempObj.phoneNum !== null?.phoneNum) !== undefined
          ? tempObj.phoneNum?.trim()
          : '';
      setContactDetail(tempObj);
    }
  }, [Array.isArray(contactDetails) && contactDetails.length > 0]);
  // check form level validation after onclick on save button
  const validateRequest = () => {
    const errorMessagesArray = [];
    setSuccessMessage([]);
    if (contactDetail && Object.keys(contactDetail).length === 0) {
      setContactDetail(initializeContact);
      addReduxDataUpdateManufacturerTab({
        ...addEditManufacturerTabData,
        errorMessages: [],
        contactDetail: initializeContact,
      });
    }
    let showLabelerStartDateErr = false;
    let showLabelerEndDateErr = false;
    let showMFGNameErr = false;
    let showMFGIdErr = false;
    let showNameErr = false;
    let showAddrErr = false;
    let showCityErr = false;
    let showStateErr = false;
    let showZipErr = false;
    let showZip4Err = false;
    let showPhoneErr = false;
    let showEmailErr = false;
    let showDefPaperFinalQTRErr = false;
    let showDefCmsElectFinalQTRErr = false;
    let showDefNcpSummaryFinalQtrErr = false;
    let showDefNcpdpClaimMbFinalQTRErr = false;
    let showDefPrintImageFinalQtrErr = false;
    let showDefNcpdpClaimOwnFinalQTRErr = false;
    let showBankruptcyTypeCdErr = false;
    let showBankruptcyStartDateErr = false;
    let showBankruptcyEndDateErr = false;
    let showBankruptcyOverlappingErr = false;
    let mfgNameError = '';
    let mfgIdError = '';
    if (values.mfgId === '' || values.mfgId === null) {
      showMFGIdErr = true;
      mfgIdError = constantMessageData.MANUFACTURER_ID_REQUIRED;
      errorMessagesArray.push(constantMessageData.MANUFACTURER_ID_REQUIRED);
    } else if (
      values.mfgTypeCd === 'G' &&
      AppConstants.NUMBER_REGEX.test(values.mfgId) === false
    ) {
      showMFGIdErr = true;
      mfgIdError = constantMessageData.MANUFACTURER_ID_ONLY_NUMBER;
      errorMessagesArray.push(mfgIdError);
    } else if (values.mfgTypeCd === 'G' && values.mfgId.length <= 4) {
      showMFGIdErr = true;
      mfgIdError = constantMessageData.MANUFACTURER_ID_INVALID_FORMAT_ERROR;
      errorMessagesArray.push(mfgIdError);
    }
    if (
      values.mfgId !== '' &&
      values.mfgTypeCd === 'C' &&
      AppConstants.ALPHA_NUMBER_ONLY_REGEX.test(values.mfgId)
    ) {
      showMFGIdErr = true;
      mfgIdError = constantMessageData.MANUFACTURER_ID_COM_INVALID_FORMAT_ERROR;
      errorMessagesArray.push(mfgIdError);
    }
    if (
      (values.mfgName === '' || values.mfgName === null) &&
      showMFGNameErr === false
    ) {
      showMFGNameErr = true;
      mfgNameError = constantMessageData.MANUFACTURER_NAME_REQUIRED;
      errorMessagesArray.push(mfgNameError);
    }
    if (dirtyTabs.three) {
      // CMS* contact fields are read-only — skip field-level validation for them.
      const isContactFieldsDisabled =
        contactDetail?.contactTypeCd &&
        String(contactDetail.contactTypeCd).substring(0, 3) === 'CMS';
      if (!isContactFieldsDisabled) {
    if (!contactDetail.contactName) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showNameErr = true;
    }
    if (
      contactDetail.addrLine1 === '' ||
      contactDetail.addrLine1 == undefined
    ) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showAddrErr = true;
    }
    if (contactDetail.city === '' || contactDetail.city == undefined) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showCityErr = true;
    }
    if (contactDetail.stateCd === '' || contactDetail.stateCd == undefined) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showStateErr = true;
    }
    if (!contactDetail.zip) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showZipErr = true;
    }
    if (contactDetail.phoneNum === '' || contactDetail.phoneNum === undefined) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showPhoneErr = true;
    }
    if (
      contactDetail.phoneNum !== '' &&
      contactDetail.phoneNum !== null &&
      contactDetail.phoneNum?.trim().length <= 9
    ) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showPhoneErr = true;
    }
    if (
      contactDetail.zip4 !== '' &&
      contactDetail.zip4 !== null &&
      contactDetail.zip4 !== undefined &&
      contactDetail.zip4.length <= 3
    ) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showZip4Err = true;
    }
    if (contactDetail.email === '' || contactDetail.email === undefined) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showEmailErr = true;
    }
    if (
      contactDetail.email !== '' &&
      contactDetail.email !== null &&
      !AppConstants.EMAIL_ID_REGEX.test(contactDetail.email?.trim())
    ) {
      errorMessagesArray.push(constantMessageData.MFG_CONTACT_DETAILS_ERROR);
      showEmailErr = true;
    }
      }
    }
    if (tabValue === 'two') {
    if (
      manufacturerDetail.defPaperFinalQtr !== '' &&
      manufacturerDetail.defPaperFinalQtr !== null &&
      !convertQuatreManufacturer(manufacturerDetail.defPaperFinalQtr)
    ) {
      showDefPaperFinalQTRErr = true;
      errorMessagesArray.push(constantMessageData.QUARTER_FORMAT_ERROR);
    }
    if (
      manufacturerDetail.defCmsElectFinalQtr !== '' &&
      manufacturerDetail.defCmsElectFinalQtr !== null &&
      !convertQuatreManufacturer(manufacturerDetail.defCmsElectFinalQtr)
    ) {
      showDefCmsElectFinalQTRErr = true;
      errorMessagesArray.push(constantMessageData.QUARTER_FORMAT_ERROR);
    }
    if (
      manufacturerDetail.defNcpdpSummaryFinalQtr !== '' &&
      manufacturerDetail.defNcpdpSummaryFinalQtr !== null &&
      !convertQuatreManufacturer(manufacturerDetail.defNcpdpSummaryFinalQtr)
    ) {
      showDefNcpSummaryFinalQtrErr = true;
      errorMessagesArray.push(constantMessageData.QUARTER_FORMAT_ERROR);
    }
    if (
      manufacturerDetail.defNcpdpClaimOwnFinalQtr !== '' &&
      manufacturerDetail.defNcpdpClaimOwnFinalQtr !== null &&
      !convertQuatreManufacturer(manufacturerDetail.defNcpdpClaimOwnFinalQtr)
    ) {
      showDefNcpdpClaimOwnFinalQTRErr = true;
      errorMessagesArray.push(constantMessageData.QUARTER_FORMAT_ERROR);
    }
    if (
      manufacturerDetail.defPrintImageFinalQtr !== '' &&
      manufacturerDetail.defPrintImageFinalQtr !== null &&
      !convertQuatreManufacturer(manufacturerDetail.defPrintImageFinalQtr)
    ) {
      showDefPrintImageFinalQtrErr = true;
      errorMessagesArray.push(constantMessageData.QUARTER_FORMAT_ERROR);
    }
    if (
      manufacturerDetail.defNcpdpClaimMbFinalQtr !== '' &&
      manufacturerDetail.defNcpdpClaimMbFinalQtr !== null &&
      !convertQuatreManufacturer(manufacturerDetail.defNcpdpClaimMbFinalQtr)
    ) {
      showDefNcpdpClaimMbFinalQTRErr = true;
      errorMessagesArray.push(constantMessageData.QUARTER_FORMAT_ERROR);
    }
    }
    if (tabValue === 'one') {
    const newObj = [...labelerRowData];
    for (let i = 0; i < labelerRowData.length; i++) {
      if (
        labelerRowData[i].startDate === '' ||
        labelerRowData[i].startDate === null
      ) {
        showLabelerStartDateErr = true;
        errorMessagesArray.push(constantMessageData.START_DATE_REQUIRED);
        newObj[i].startDateErr = true;
        dispatch(maintainLabelerListData(newObj, 'verify'));
      } else if (
        labelerRowData[i].startDate !== '' &&
        labelerRowData[i].startDate !== null &&
        validDate(new Date(labelerRowData[i].startDate)) === false
      ) {
        showLabelerStartDateErr = true;
        errorMessagesArray.push(constantMessageData.DATE_INVALID_FORMAT_ERROR);
        newObj[i].startDateErr = true;
        dispatch(maintainLabelerListData(newObj, 'verify'));
      } else if (
        compareTwoDatesGreaterThanOrEqual(
          new Date(labelerRowData[i].startDate),
          moment(MinDate)
        )
      ) {
        showLabelerStartDateErr = true;
        errorMessagesArray.push(constantMessageData.MFG_START_DATE_ERROR);
        newObj[i].startDateErr = true;
        dispatch(maintainLabelerListData(newObj, 'verify'));
      }
      if (
        labelerRowData[i].endDate !== '' &&
        labelerRowData[i].endDate !== null &&
        labelerRowData[i].endDate !== 'Invalid date' &&
        validDate(new Date(labelerRowData[i].endDate)) === false
      ) {
        showLabelerEndDateErr = true;
        errorMessagesArray.push(constantMessageData.DATE_INVALID_FORMAT_ERROR);
        newObj[i].endDateErr = true;
        newObj[i].endDate = null;
        dispatch(maintainLabelerListData(newObj, 'verify'));
      } else if (
        labelerRowData[i].endDate !== '' &&
        labelerRowData[i].endDate !== null &&
        labelerRowData[i].endDate !== 'Invalid date' &&
        compareTwoDatesGreaterThanOrEqual(
          new Date(labelerRowData[i].endDate),
          moment(new Date(labelerRowData[i].startDate))
        )
      ) {
        showLabelerEndDateErr = true;
        errorMessagesArray.push(constantMessageData.MFG_LABELER_END_DATE_ERROR);
        newObj[i].endDateErr = true;
        newObj[i].endDate = null;
        dispatch(maintainLabelerListData(newObj, 'verify'));
      } else if (labelerRowData[i].endDate === 'Invalid date') {
        newObj[i].endDateErr = false;
        newObj[i].endDate = null;
        dispatch(maintainLabelerListData(newObj, 'verify'));
      }
    }
    }
    if (tabValue === 'four') {
    const objBankruptcy = [...bankruptcyRowData];
    for (let i = 0; i < bankruptcyRowData.length; i++) {
      if (
        !(
          bankruptcyRowData[i].bankruptcyTypeCd !== '' &&
          bankruptcyRowData[i].bankruptcyTypeCd !== null &&
          bankruptcyRowData[i].bankruptcyTypeCd !== '-1'
        )
      ) {
        showBankruptcyTypeCdErr = true;
        errorMessagesArray.push(
          constantMessageData.MFG_BANKRUPTCY_TYPE_REQUIRED
        );
        objBankruptcy[i].bankruptcyTypeCdErr = true;
        dispatch(addNewRowBankruptcy(objBankruptcy, 'verify'));
      }
      if (
        bankruptcyRowData[i].startDate === '' ||
        bankruptcyRowData[i].startDate === null
      ) {
        showBankruptcyStartDateErr = true;
        errorMessagesArray.push(constantMessageData.START_DATE_REQUIRED);
        objBankruptcy[i].startDateErr = true;
        dispatch(addNewRowBankruptcy(objBankruptcy, 'verify'));
      } else if (
        bankruptcyRowData[i].startDate != '' &&
        bankruptcyRowData[i].startDate !== null &&
        validDate(new Date(bankruptcyRowData[i].startDate)) === false
      ) {
        showBankruptcyStartDateErr = true;
        errorMessagesArray.push(constantMessageData.DATE_INVALID_FORMAT_ERROR);
        objBankruptcy[i].startDateErr = true;
        dispatch(addNewRowBankruptcy(objBankruptcy, 'verify'));
      } else if (
        objBankruptcy[i].startDate !== null &&
        objBankruptcy[i].startDate !== '' &&
        compareTwoDatesGreaterThanOrEqual(
          new Date(bankruptcyRowData[i].startDate),
          moment(MinDate)
        )
      ) {
        showBankruptcyStartDateErr = true;
        errorMessagesArray.push(constantMessageData.MFG_START_DATE_ERROR);
        objBankruptcy[i].startDateErr = true;
        dispatch(addNewRowBankruptcy(objBankruptcy, 'verify'));
      }
      if (
        bankruptcyRowData[i].endDate !== '' &&
        bankruptcyRowData[i].endDate !== null &&
        bankruptcyRowData[i].endDate !== 'Invalid date' &&
        validDate(new Date(bankruptcyRowData[i].endDate)) === false
      ) {
        showBankruptcyEndDateErr = true;
        errorMessagesArray.push(constantMessageData.DATE_INVALID_FORMAT_ERROR);
        objBankruptcy[i].endDateErr = true;
        dispatch(addNewRowBankruptcy(objBankruptcy, 'verify'));
      } else if (bankruptcyRowData[i].endDate === 'Invalid date') {
        objBankruptcy[i].endDateErr = false;
        objBankruptcy[i].endDate = null;
        dispatch(addNewRowBankruptcy(objBankruptcy, 'verify'));
      }
      if (
        bankruptcyRowData[i].endDate !== '' &&
        bankruptcyRowData[i].endDate !== null &&
        validDate(new Date(bankruptcyRowData[i].endDate)) &&
        validDate(new Date(bankruptcyRowData[i].startDate)) &&
        compareTwoDatesGreaterThanOrEqual(
          new Date(bankruptcyRowData[i].endDate),
          moment(new Date(bankruptcyRowData[i].startDate)).add('days', 1)
        )
      ) {
        showBankruptcyEndDateErr = true;
        errorMessagesArray.push(
          constantMessageData.MFG_BANKRUPTCY_END_DATE_ERROR
        );
        objBankruptcy[i].endDateErr = true;
        dispatch(addNewRowBankruptcy(objBankruptcy, 'verify'));
      } else if (
        bankruptcyRowData[i].endDate === '' ||
        bankruptcyRowData[i].endDate === 'Invalid date'
      ) {
        objBankruptcy[i].endDateErr = false;
        objBankruptcy[i].endDate = null;
        dispatch(addNewRowBankruptcy(objBankruptcy, 'verify'));
      }
      if (
        (errorMessagesArray &&
          errorMessagesArray.length > 0 &&
          errorMessagesArray.filter((x) => {
            return (
              x === constantMessageData.DATE_INVALID_FORMAT_ERROR ||
              x === constantMessageData.START_DATE_REQUIRED ||
              x === constantMessageData.MFG_BANKRUPTCY_END_DATE_ERROR ||
              x === constantMessageData.MFG_START_DATE_ERROR ||
              x.includes('Start Date is required')
            );
          }).length === 0) ||
        (errorMessagesArray && errorMessagesArray.length === 0)
      ) {
        bankruptcyRowData.map((item, RowNum) => {
          if (
            i !== RowNum &&
            bankruptcyRowData[i].bankruptcyTypeCd?.trim() ==
              item.bankruptcyTypeCd?.trim()
          ) {
            if (
              moment(new Date(bankruptcyRowData[i].startDate)).format(
                'MM/DD/YYYY'
              ) === moment(new Date(item.startDate)).format('MM/DD/YYYY') ||
              moment(
                new Date(
                  bankruptcyRowData[i].endDate !== null ||
                  bankruptcyRowData[i].endDate != 'Invalid date' ||
                  bankruptcyRowData[i].endDate != ''
                    ? bankruptcyRowData[i].endDate
                    : '12/31/9999'
                )
              ).format('MM/DD/YYYY') ===
                moment(
                  new Date(
                    item.endDate !== null || item.endDate != ''
                      ? item.endDate
                      : '12/31/9999'
                  )
                ).format('MM/DD/YYYY')
            ) {
              if (
                (errorMessagesArray &&
                  errorMessagesArray.length > 0 &&
                  errorMessagesArray.filter((x) => {
                    return x.includes(
                      constantMessageData.MFG_BANKRUPTCY_OVERLAPPING_ERROR
                    );
                  }).length === 0) ||
                (errorMessagesArray && errorMessagesArray.length === 0)
              ) {
                return (
                  (showBankruptcyOverlappingErr = true),
                  errorMessagesArray.push(
                    `${constantMessageData.MFG_BANKRUPTCY_OVERLAPPING_ERROR} ${
                      RowNum >= i ? i + 1 : RowNum + 1
                    } and row ${RowNum <= i ? i + 1 : RowNum + 1}.`
                  )
                );
              }
            } else if (
              RowNum !== 0 &&
              i !== bankruptcyRowData.length - 1 &&
              new Date(item.startDate).getTime() >=
                new Date(bankruptcyRowData[i].startDate).getTime() &&
              new Date(item.startDate).getTime() <=
                new Date(
                  bankruptcyRowData[i].endDate !== null ||
                  bankruptcyRowData[i].endDate != 'Invalid date' ||
                  bankruptcyRowData[i].endDate != ''
                    ? bankruptcyRowData[i].endDate
                    : '12/31/9999'
                ).getTime()
            ) {
              if (
                RowNum !== 0 &&
                i !== bankruptcyRowData.length - 1 &&
                compareTwoDatesGreaterThanOrEqual(
                  new Date(item.startDate),
                  moment(
                    new Date(
                      bankruptcyRowData[i].endDate !== null ||
                        bankruptcyRowData[i].endDate != ''
                    )
                      ? bankruptcyRowData[i].endDate
                      : '12/31/9999'
                  ).add('days', 1)
                )
              ) {
                if (
                  (errorMessagesArray &&
                    errorMessagesArray.length > 0 &&
                    errorMessagesArray.filter((x) => {
                      return x.includes(
                        constantMessageData.MFG_BANKRUPTCY_OVERLAPPING_ERROR
                      );
                    }).length === 0) ||
                  (errorMessagesArray && errorMessagesArray.length === 0)
                ) {
                  return (
                    (showBankruptcyOverlappingErr = true),
                    errorMessagesArray.push(
                      `${
                        constantMessageData.MFG_BANKRUPTCY_OVERLAPPING_ERROR
                      } ${RowNum >= i ? i + 1 : RowNum + 1} and row ${
                        RowNum <= i ? i + 1 : RowNum + 1
                      }.`
                    )
                  );
                }
              }
            }
          }
        });
      }
    }
    }
    if (
      showMFGIdErr ||
      showMFGNameErr ||
      showLabelerStartDateErr ||
      showLabelerEndDateErr ||
      showNameErr ||
      showAddrErr ||
      showCityErr ||
      showStateErr ||
      showZipErr ||
      showZip4Err ||
      showPhoneErr ||
      showEmailErr ||
      showDefPaperFinalQTRErr ||
      showDefCmsElectFinalQTRErr ||
      showDefNcpSummaryFinalQtrErr ||
      showDefNcpdpClaimMbFinalQTRErr ||
      showDefPrintImageFinalQtrErr ||
      showDefNcpdpClaimOwnFinalQTRErr ||
      showBankruptcyTypeCdErr ||
      showBankruptcyStartDateErr ||
      showBankruptcyEndDateErr ||
      showBankruptcyOverlappingErr
    ) {
      setError({
        ...error,
        mfgId_Error: mfgIdError,
        mfgName_Error: mfgNameError,
      });
      setShowError({
        showMFGIdErr,
        showLabelerStartDateErr,
        showLabelerEndDateErr,
        showNameErr,
        showAddrErr,
        showCityErr,
        showStateErr,
        showZipErr,
        showZip4Err,
        showPhoneErr,
        showEmailErr,
        showDefPaperFinalQTRErr,
        showDefCmsElectFinalQTRErr,
        showDefNcpSummaryFinalQtrErr,
        showDefNcpdpClaimMbFinalQTRErr,
        showDefPrintImageFinalQtrErr,
        showDefNcpdpClaimOwnFinalQTRErr,
        showBankruptcyTypeCdErr,
        showBankruptcyStartDateErr,
        showBankruptcyEndDateErr,
        showBankruptcyOverlappingErr,
      });
      addReduxDataUpdateManufacturerTab({
        ...addEditManufacturerTabData,
        error: {
          ...error,
          mfgId_Error: mfgIdError,
          mfgName_Error: mfgNameError,
        },
        errorMessages: [...new Set(errorMessagesArray)],
        showLabelerStartDateErr,
        showLabelerEndDateErr,
        showMFGIdErr,
        showNameErr,
        showAddrErr,
        showCityErr,
        showStateErr,
        showZipErr,
        showZip4Err,
        showPhoneErr,
        showEmailErr,
        showDefPaperFinalQTRErr,
        showDefCmsElectFinalQTRErr,
        showDefNcpSummaryFinalQtrErr,
        showDefNcpdpClaimMbFinalQTRErr,
        showDefPrintImageFinalQtrErr,
        showDefNcpdpClaimOwnFinalQTRErr,
        showBankruptcyTypeCdErr,
        showBankruptcyStartDateErr,
        showBankruptcyEndDateErr,
        showBankruptcyOverlappingErr,
      });
      setErrorMessages([...new Set(errorMessagesArray)]);
      setSuccessMessage([]);

      return false;
    }
    addReduxDataUpdateManufacturerTab({
      ...addEditManufacturerTabData,
      error: { ...error, mfgIdError: '', mfgName_Error: '' },
      errorMessages: [],
      showLabelerStartDateErr,
      showLabelerEndDateErr,
      showMFGIdErr,
      showNameErr,
      showAddrErr,
      showCityErr,
      showStateErr,
      showZipErr,
      showZip4Err,
      showPhoneErr,
      showEmailErr,
      showDefPaperFinalQTRErr,
      showDefCmsElectFinalQTRErr,
      showDefNcpSummaryFinalQtrErr,
      showDefNcpdpClaimOwnFinalQTRErr,
      showDefNcpdpClaimMbFinalQTRErr,
      showDefPrintImageFinalQtrErr,
      showBankruptcyTypeCdErr,
      showBankruptcyStartDateErr,
      showBankruptcyEndDateErr,
      showBankruptcyOverlappingErr,
    });
    return true;
  };
  // click on save button after call function
  const onSubmit = async (value) => {
    setClickOncloseTabBtn(value);
    if (validateRequest()) {
      let result = false;
      const res = await getExistingManufactureId({
        mfgId: values.mfgId,
      });
      if (createMFG && res?.existMfg) {
        result = true;
        setError({
          ...error,
          mfgIdError: constantMessageData.MANUFACTURE_ID_ALREADY_EXIT_MSG,
        });
        setErrorMessages([
          ...new Set([constantMessageData.MANUFACTURE_ID_ALREADY_EXIT_MSG]),
        ]);
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: {
            ...error,
            mfgIdError: constantMessageData.MANUFACTURE_ID_ALREADY_EXIT_MSG,
          },
          errorMessages: [
            ...new Set([constantMessageData.MANUFACTURE_ID_ALREADY_EXIT_MSG]),
          ],
        });
      }
      if (!result) {
        setErrorMessages([]);
        setSuccessMessage([]);
        openSave(value);
      }
    } else {
      handleScrollToEvent();
    }
  };
  // close popup on click button
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/manufacturer-detail' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/manufacturer-detail' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // click on confirm popup button after call function
  const masterDataSave = () => {
    handleScrollToEvent();
    handleSaveClose();
    handelCancelClose();
    setSpinnerLoader(true);
    if (permanentDeleteLabelerList && permanentDeleteLabelerList.length > 0) {
      permanentDeleteLabelerList.forEach((item) => {
        return deleteSingleLabeler({
          mfgId: values.mfgId,
          labelerCode: item.labelerCode,
          startDt: item.startDate,
        });
      });
    }
    let labelerArrayList = [];
    labelerArrayList =
      labelerRowData &&
      labelerRowData.length > 0 &&
      labelerRowData.map((prop) => {
        const startDate = prop.startDate
          ? new Date(prop.startDate).setHours(0)
          : null;
        if (startDate !== null) new Date(prop.startDate).setMinutes(0);
        const endDate = prop.endDate
          ? new Date(prop.endDate).setHours(0)
          : null;
        if (endDate !== null) new Date(prop.endDate).setMinutes(0);
        return {
          // labelerName: prop.labelerName,
          // labelerCode: prop.labelerCode,
          // lastUpdateDt: startDate
          //   ? moment(startDate).format('MM/DD/YYYY HH:mm')
          //   : null,
          // endDate: endDate ? moment(endDate).format('MM/DD/YYYY HH:mm') : null,
          // lastUpdateUserId: logInUser, //prop.lastUpdateUserId,
          // corrLinkId: prop.corrLinkId,
          endDate: endDate ? moment.utc(endDate).format('MM/DD/YYYY') : null,
          labelerCode: prop.labelerCode,
          mfgId: values.mfgId,
          mfgName: values.mfgName,
          mfgType: values.mfgTypeCd,
          startDt: startDate
            ? moment.utc(startDate).format('MM/DD/YYYY')
            : null,
        };
      });
    let bankruptcyArrayData = [];
    bankruptcyArrayData =
      bankruptcyRowData &&
      bankruptcyRowData.length > 0 &&
      bankruptcyRowData
        ?.filter((x) => {
          return x.addNewBankruptcy ? true : x.addEditRow;
        })
        .map((prop) => {
          let startDate = null;
          if (
            !createMFG &&
            prop.permanentDelete &&
            prop.mfgBankCruptcyId &&
            prop.mfgBankCruptcyId.startDate
          ) {
            startDate =
              moment(prop.startDate).format('MM/DD/yyyy') ===
              moment(prop.mfgBankCruptcyId.startDate).format('MM/DD/yyyy')
                ? prop.mfgBankCruptcyId.startDate
                : prop.startDate;
          } else {
            startDate = prop.startDate
              ? new Date(prop.startDate).setHours(0)
              : null;
            if (startDate !== null)
              startDate = new Date(prop.startDate).setMinutes(0);
          }
          const endDate = prop.endDate
            ? new Date(prop.endDate).setHours(0)
            : null;
          if (endDate !== null) new Date(prop.endDate).setMinutes(0);

          return {
            mfgBankCruptcyId: {
              mfgId: values.mfgId,
              bankruptcyTypeCd: prop.bankruptcyTypeCd,
              startDate: startDate
                ? moment(startDate).format('MM/DD/YYYY HH:mm')
                : null,
            },
            endDate: endDate
              ? moment(endDate).format('MM/DD/YYYY HH:mm')
              : null,
            inclInvoiceInd: prop.inclInvoiceInd ? 1 : 0,
            // corrLinkId: prop.corrLinkId,
            addedDate: prop.addedDate,
            addedUserId: logInUser, //prop.addedUserId,
          };
        });
    const details = { ...manufacturerDetail };
    details.mfgId = values.mfgId;
    details.mfgName = values.mfgName;
    details.mfgTypeCd = values.mfgTypeCd;
    details.corrLinkId = values.corrLinkId;
    details.defPricingTimingCd =
      details.defPricingTimingCd === '' || details.defPricingTimingCd === '-1'
        ? null
        : details.defPricingTimingCd;
    details.defEnrollmentTimingCd =
      details.defEnrollmentTimingCd === '' ||
      details.defEnrollmentTimingCd === '-1'
        ? null
        : details.defEnrollmentTimingCd;
    details.defCollectionMediumCd =
      details.defCollectionMediumCd === '' ||
      details.defCollectionMediumCd === '-1'
        ? null
        : details.defCollectionMediumCd;
    details.defPaperFinalQtr =
      details.defPaperFinalQtr === '' ? null : details.defPaperFinalQtr;
    details.defCmsElectFinalQtr =
      details.defCmsElectFinalQtr === '' ? null : details.defCmsElectFinalQtr;
    details.defNcpdpSummaryFinalQtr =
      details.defNcpdpSummaryFinalQtr === ''
        ? null
        : details.defNcpdpSummaryFinalQtr;
    details.defNcpdpClaimOwnFinalQtr =
      details.defNcpdpClaimOwnFinalQtr === ''
        ? null
        : details.defNcpdpClaimOwnFinalQtr;
    details.defNcpdpClaimMbFinalQtr =
      details.defNcpdpClaimMbFinalQtr === ''
        ? null
        : details.defNcpdpClaimMbFinalQtr;
    details.defPrintImageFinalQtr =
      details.defPrintImageFinalQtr === ''
        ? null
        : details.defPrintImageFinalQtr;
    const deleteMfgBankruptcyVO = [];
    if (updateBankruptcyList?.length > 0) {
      if (
        bankruptcyRowData.filter((x) => {
          return x.addEditRow && !x.addNewBankruptcy;
        })?.length > 0
      ) {
        bankruptcyRowData
          .filter((x) => {
            return x.addEditRow && !x.addNewBankruptcy;
          })
          .map((item) => {
            const rowItem = updateBankruptcyList?.filter((x) => {
              return x.id === item.id;
            })[0];
            deleteMfgBankruptcyVO.push({
              mfgBankCruptcyId: item?.mfgBankCruptcyId,
              endDate:
                rowItem?.endDate && rowItem?.endDate !== 'Invalid date'
                  ? moment(rowItem?.endDate).format('MM/DD/YYYY HH:mm')
                  : null,
              inclInvoiceInd: rowItem?.inclInvoiceInd ? 1 : 0,
              addedDate: item?.addedDate,
              addedUserId: item?.addedUserId,
            });
            return item;
          });
      }
    }
    const saveRequest = {
      contactVO: {},
      mfgVO: {},
      labelerVO: [],
      deleteMfgBankruptcyVO: [],
      saveMfgBankruptcyVO: [],
    };
    const contactCompareFields = [
      'contactName',
      'corpName',
      'addrLine1',
      'addrLine2',
      'addrLine3',
      'city',
      'stateCd',
      'zip',
      'zip4',
      'phoneNum',
      'phoneExtension',
      'faxNum',
      'email',
    ];
    const normalizeContactField = (value) => {
      if (value === null || value === undefined) return '';
      return typeof value === 'string' ? value.trim() : String(value);
    };
    const isContactFormUnchanged =
      originalContactDetailRef.current &&
      contactCompareFields.every(
        (field) =>
          normalizeContactField(contactDetail?.[field]) ===
          normalizeContactField(originalContactDetailRef.current?.[field])
      );
    if (!isContactFormUnchanged) {
      const objContact = { ...contactDetail };
      objContact.key = values.mfgId;
      objContact.keyTypeCd = 'MFG';
      saveRequest.contactVO = { ...objContact, lastUpdateUserID: logInUser };
    }
    saveRequest.mfgVO = { ...details, lastUpdateUserId: logInUser };
    saveRequest.labelerVO =
      labelerArrayList === false ? null : labelerArrayList;
    saveRequest.searchLabelerVO = labelerArrayList || [];
    saveRequest.saveMfgBankruptcyVO =
      bankruptcyArrayData === false ? null : bankruptcyArrayData;
    saveRequest.deleteMfgBankruptcyVO =
      deleteMfgBankruptcyVO?.length > 0 ? deleteMfgBankruptcyVO : [];
    dispatch(fetchAllManufacturerDetail(null));
    saveOrUpdate(saveRequest);
    resetUpdateOrSaveMessageHandler('');
  };
  // reset call values
  const resetAllFields = () => {
    handleScrollToEvent();
    dispatch(setMaintainManufacturerTab({}));
    setErrorMessages([]);
    setSuccessMessage([]);
    handleSaveClose();
    handelCancelClose();
    setDisabledSaveCancelBtn(true);
    setDirtyTabs({});
    setTabValue('one');
    setError({
      mfgId_Error: '',
      mfgName_Error: '',
    });
    if (createMFG) {
      const newObj = {
        labelerCode: '',
        labelerName: '',
        startDate: null,
        lastUpdateDt: '',
        endDate: null,
        lastUpdateUserId: null,
        corrLinkId: null,
        mfgId: null,
        startDateErr: false,
        endDateErr: false,
        mfgTypeCd: selectMFGData?.mfgTypeCd,
        ccCommentsExist: 0,
      };
      if (selectMFGData?.mfgTypeCd == 'G') {
        dispatch(maintainLabelerListData(newObj, selectMFGData.mfgTypeCd));
      } else if (labelerRowData && labelerRowData.length > 0)
        dispatch(maintainLabelerListData({}));
      setContactDetail(initializeContact);
      originalContactDetailRef.current = JSON.parse(
        JSON.stringify(initializeContact)
      );
      setManufacturerDetail(initializeManufacturerDetail);
      setValues({
        mfgId: '',
        mfgName: '',
        mfgTypeCd: selectMFGData.mfgTypeCd,
        corrLinkId: null,
      });
    } else {
      // Clear stale contactDetails from a Contact Type change so remounting
      // Contact tab cannot re-apply the dirty type before the restore fetch.
      getContactDetailsValue(null);
      fetchDataFromServer({ skipContactReset: true });
      // Restore Contact Type and fields to the last clean snapshot.
      if (originalContactDetailRef.current) {
        setContactDetail(
          JSON.parse(JSON.stringify(originalContactDetailRef.current))
        );
      }
      setCallContactDetailApi(true);
    }

    setShowError({
      showLabelerStartDateErr: false,
      showLabelerEndDateErr: false,
      showNameErr: false,
      showAddrErr: false,
      showCityErr: false,
      showStateErr: false,
      showZipErr: false,
      showZip4Err: false,
      showPhoneErr: false,
      showEmailErr: false,
      showDefPaperFinalQTRErr: false,
      showDefCmsElectFinalQTRErr: false,
      showDefNcpSummaryFinalQtrErr: false,
      showDefNcpdpClaimOwnFinalQTRErr: false,
      showDefNcpdpClaimMbFinalQTRErr: false,
      showDefPrintImageFinalQtrErr: false,
      showBankruptcyTypeCdErr: false,
      showBankruptcyStartDateErr: false,
      showBankruptcyEndDateErr: false,
      showBankruptcyOverlappingErr: false,
    });
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/manufacturer-detail') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };
  // check Validation duplicate manufacture Id
  const handleDuplicateManufactureId = async (mfgId, errorMessagesArray) => {
    if (createMFG && mfgId) {
      const result = await getExistingManufactureId({
        mfgId: mfgId,
      });
      if (result?.existMfg) {
        setError({
          ...error,
          mfgIdError: constantMessageData.MANUFACTURE_ID_ALREADY_EXIT_MSG,
        });
        errorMessagesArray.push(
          constantMessageData.MANUFACTURE_ID_ALREADY_EXIT_MSG
        );
        setErrorMessages([...new Set(errorMessagesArray)]);
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: {
            ...error,
            mfgIdError: constantMessageData.MANUFACTURE_ID_ALREADY_EXIT_MSG,
          },
          errorMessages: [...new Set(errorMessagesArray)],
        });
        return true;
      }
      if (!result?.existMfg) {
        setError({ ...error, mfgIdError: '' });
        errorMessagesArray?.length > 0 &&
          errorMessagesArray.forEach((item, key) => {
            if (
              item.includes('This manufacturer Id already exists') ||
              item == constantMessageData.MANUFACTURER_ID_REQUIRED ||
              item == constantMessageData.MANUFACTURER_ID_ONLY_NUMBER ||
              item == constantMessageData.MANUFACTURER_ID_INVALID_FORMAT_ERROR
            ) {
              return (
                errorMessagesArray.splice(key, 1),
                setErrorMessages([...new Set(errorMessagesArray)]),
                addReduxDataUpdateManufacturerTab({
                  ...addEditManufacturerTabData,
                  errorMessages: [...new Set(errorMessagesArray)],
                })
              );
            }
          });

        return false;
      }
      return false;
    }
  };
  // check validation on blur Event
  const handleOnBlurEv = (e) => {
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    const errorMessagesArray =
      errorMessages && errorMessages.length > 0 ? [...errorMessages] : [];
    let mfgIdError = '';
    if (values.mfgTypeCd === 'G') {
      const newObj = {
        labelerCode: e.target.value,
        labelerName: values.mfgName,
        startDate: labelerRowData[0].startDate,
        lastUpdateDt: labelerRowData[0].startDate,
        endDate: null,
        lastUpdateUserId: null,
        corrLinkId: null,
        mfgId: null,
        mfgTypeCd: 'G',
        startDateErr: false,
        endDateErr: false,
        ccCommentsExist: 0,
      };
      dispatch(maintainLabelerListData(newObj, selectMFGData.mfgTypeCd));
      if (e.target.value === '') {
        mfgIdError = constantMessageData.MANUFACTURER_ID_REQUIRED;
        setError({ ...error, mfgIdError: mfgIdError });
        errorMessagesArray.push(mfgIdError);
        setErrorMessages([...new Set(errorMessagesArray)]);
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: { ...error, mfgIdError: mfgIdError },
          errorMessages: [...new Set(errorMessagesArray)],
        });
      } else {
        errorMessagesArray?.length > 0 &&
          errorMessagesArray.forEach((item, key) => {
            if (
              item === constantMessageData.MANUFACTURER_ID_REQUIRED ||
              item.includes('This manufacturer Id already exists')
            ) {
              return (
                errorMessagesArray.splice(key, 1),
                setErrorMessages([...new Set(errorMessagesArray)])
              );
            }
          });
        setError({ ...error, mfgIdError: '' });
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: { ...error, mfgIdError: '' },
          errorMessages: [...new Set(errorMessagesArray)],
        });
      }
      if (
        e.target.value !== '' &&
        AppConstants.NUMBER_REGEX.test(e.target.value) === false
      ) {
        mfgIdError = constantMessageData.MANUFACTURER_ID_ONLY_NUMBER;
        setError({ ...error, mfgIdError: mfgIdError });
        errorMessagesArray.push(mfgIdError);
        setErrorMessages([...new Set(errorMessagesArray)]);
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: { ...error, mfgIdError: mfgIdError },
          errorMessages: [...new Set(errorMessagesArray)],
        });
        errorMessagesArray?.length > 0 &&
          errorMessagesArray.forEach((item, key) => {
            if (
              item ===
                constantMessageData.MANUFACTURER_ID_INVALID_FORMAT_ERROR ||
              item.includes('This manufacturer Id already exists')
            ) {
              return (
                errorMessagesArray.splice(key, 1),
                setErrorMessages([...new Set(errorMessagesArray)]),
                addReduxDataUpdateManufacturerTab({
                  ...addEditManufacturerTabData,
                  errorMessages: [...new Set(errorMessagesArray)],
                })
              );
            }
          });
      } else if (e.target.value !== '' && e.target.value.length <= 4) {
        mfgIdError = constantMessageData.MANUFACTURER_ID_INVALID_FORMAT_ERROR;
        setError({ ...error, mfgIdError: mfgIdError });
        errorMessagesArray.push(mfgIdError);
        setErrorMessages([...new Set(errorMessagesArray)]);
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: { ...error, mfgIdError: mfgIdError },
          errorMessages: [...new Set(errorMessagesArray)],
        });

        errorMessagesArray?.length > 0 &&
          errorMessagesArray.forEach((item, key) => {
            if (
              item === constantMessageData.MANUFACTURER_ID_ONLY_NUMBER ||
              item.includes('This manufacturer Id already exists')
            ) {
              return (
                errorMessagesArray.splice(key, 1),
                setErrorMessages([...new Set(errorMessagesArray)]),
                addReduxDataUpdateManufacturerTab({
                  ...addEditManufacturerTabData,
                  errorMessages: [...new Set(errorMessagesArray)],
                })
              );
            }
          });
      } else {
        errorMessagesArray?.length > 0 &&
          errorMessagesArray.forEach((x, key) => {
            if (
              x === constantMessageData.MANUFACTURER_ID_INVALID_FORMAT_ERROR ||
              x === constantMessageData.MANUFACTURER_ID_ONLY_NUMBER ||
              x.includes('This manufacturer Id already exists')
            ) {
              return (
                errorMessagesArray.splice(key, 1),
                setErrorMessages([...new Set(errorMessagesArray)]),
                setError({ ...error, mfgIdError: '' }),
                addReduxDataUpdateManufacturerTab({
                  ...addEditManufacturerTabData,
                  error: { ...error, mfgIdError: '' },
                  errorMessages: [...new Set(errorMessagesArray)],
                })
              );
            }
          });
        if (
          e.target.value !== '' &&
          e.target.value.length > 4 &&
          AppConstants.NUMBER_REGEX.test(e.target.value)
        ) {
          handleDuplicateManufactureId(e.target.value, errorMessagesArray);
        }
      }
    } else {
      if (e.target.value === '') {
        mfgIdError = constantMessageData.MANUFACTURER_ID_REQUIRED;
        setError({ ...error, mfgIdError: mfgIdError });
        errorMessagesArray.push(mfgIdError);
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: { ...error, mfgIdError: mfgIdError },
          errorMessages: [...new Set(errorMessagesArray)],
        });

        setErrorMessages([...new Set(errorMessagesArray)]);
      } else {
        errorMessagesArray?.length > 0 &&
          errorMessagesArray.forEach((x, key) => {
            if (
              x === constantMessageData.MANUFACTURER_ID_REQUIRED ||
              x?.includes('This manufacturer Id already exists')
            ) {
              return (
                errorMessagesArray.splice(key, 1),
                setErrorMessages([...new Set(errorMessagesArray)])
              );
            }
          });
        setError({ ...error, mfgIdError: '' });
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: { ...error, mfgIdError: '' },
          errorMessages: [...new Set(errorMessagesArray)],
        });
      }
      if (
        e.target.value !== '' &&
        AppConstants.ALPHA_NUMBER_ONLY_REGEX.test(e.target.value)
      ) {
        mfgIdError =
          constantMessageData.MANUFACTURER_ID_COM_INVALID_FORMAT_ERROR;
        setError({ ...error, mfgIdError: mfgIdError });
        errorMessagesArray.push(mfgIdError);
        setErrorMessages([...new Set(errorMessagesArray)]);
        addReduxDataUpdateManufacturerTab({
          ...addEditManufacturerTabData,
          error: { ...error, mfgIdError: mfgIdError },
          errorMessages: [...new Set(errorMessagesArray)],
        });
      } else {
        errorMessagesArray?.length > 0 &&
          errorMessagesArray.forEach((x, key) => {
            if (
              x === constantMessageData.MANUFACTURER_ID_COM_INVALID_FORMAT_ERROR
            ) {
              return (
                errorMessagesArray.splice(key, 1),
                setErrorMessages([...new Set(errorMessagesArray)]),
                setError({ ...error, mfgIdError: '' }),
                addReduxDataUpdateManufacturerTab({
                  ...addEditManufacturerTabData,
                  error: { ...error, mfgIdError: '' },
                  errorMessages: [...new Set(errorMessagesArray)],
                })
              );
            }
          });
        if (
          e.target.value !== '' &&
          !AppConstants.ALPHA_NUMBER_ONLY_REGEX.test(e.target.value)
        ) {
          handleDuplicateManufactureId(e.target.value, errorMessagesArray);
        }
      }
    }
  };

  // check validation on blur event
  const handleOnBlurMfgName = (e) => {
    setSuccessMessage([]);
    setDisabledSaveCancelBtn(false);
    const errorMessagesArray = [...errorMessages];
    let mfgName_Error = '';
    if (e.target.value === '') {
      mfgName_Error = constantMessageData.MANUFACTURER_NAME_REQUIRED;
      setError({ ...error, mfgName_Error: mfgName_Error });
      errorMessagesArray.push(mfgName_Error);
      setErrorMessages([...new Set(errorMessagesArray)]);
      addReduxDataUpdateManufacturerTab({
        ...addEditManufacturerTabData,
        disabledSaveCancelBtn: false,
        error: { ...error, mfgName_Error: mfgName_Error },
        errorMessages: [...new Set(errorMessagesArray)],
      });
    } else {
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.forEach((x, key) => {
          if (x === constantMessageData.MANUFACTURER_NAME_REQUIRED) {
            return (
              errorMessagesArray.splice(key, 1),
              setErrorMessages([...new Set(errorMessagesArray)]),
              setError({ ...error, mfgName_Error: '' }),
              addReduxDataUpdateManufacturerTab({
                ...addEditManufacturerTabData,
                disabledSaveCancelBtn: false,
                error: { ...error, mfgName_Error: '' },
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
    }

    if (values.mfgTypeCd === 'G') {
      const newObj = {
        labelerCode: values.mfgId,
        labelerName: e.target.value,
        startDate: labelerRowData[0].startDate,
        lastUpdateDt: labelerRowData[0].startDate,
        endDate: null,
        lastUpdateUserId: null,
        corrLinkId: null,
        mfgId: null,
        mfgTypeCd: 'G',
        startDateErr: false,
        endDateErr: false,
        ccCommentsExist: 0,
      };
      dispatch(maintainLabelerListData(newObj, selectMFGData.mfgTypeCd));
    }
  };

  // check validation on blur event
  const handleOnBlurEventContactTab = (e, name) => {
    setSuccessMessage([]);
    handleTabFormDirty(false);
    const { value } = e.target;
    let showEmailErr = false;
    let showZip4Err = false;
    let showPhoneErr = false;
    const errorMessagesArray = [...errorMessages];
    if (
      name === 'email' &&
      value !== '' &&
      !AppConstants.EMAIL_ID_REGEX.test(value)
    ) {
      errorMessagesArray.push(constantMessageData.EMAIL_INVALID);
      showEmailErr = true;
    }
    if (name === 'zip4' && value !== '' && value.length <= 3) {
      errorMessagesArray.push(constantMessageData.ZIP4_REQUIRED);
      showZip4Err = true;
    }
    if (name === 'phoneNum' && value !== '' && value.length <= 9) {
      errorMessagesArray.push(constantMessageData.PHONE_INVALID_ERROR);
      showPhoneErr = true;
    }
    if (showEmailErr || showZip4Err || showPhoneErr) {
      setErrorMessages([...new Set(errorMessagesArray)]);
      addReduxDataUpdateManufacturerTab({
        ...addEditManufacturerTabData,
        disabledSaveCancelBtn: false,
        showEmailErr,
        showZip4Err,
        showPhoneErr,
        errorMessages: [...new Set(errorMessagesArray)],
      });
      setShowError({
        showLabelerStartDateErr: showLabelerStartDateErr,
        showLabelerEndDateErr: showLabelerEndDateErr,
        showNameErr: showNameErr,
        showAddrErr: showAddrErr,
        showCityErr: showCityErr,
        showStateErr: showStateErr,
        showZipErr: showZipErr,
        showZip4Err: showZip4Err,
        showPhoneErr: showPhoneErr,
        showEmailErr: showEmailErr,
        showDefPaperFinalQTRErr: showDefPaperFinalQTRErr,
        showDefCmsElectFinalQTRErr: showDefCmsElectFinalQTRErr,
        showDefNcpSummaryFinalQtrErr: showDefNcpSummaryFinalQtrErr,
        showDefNcpdpClaimOwnFinalQTRErr: showDefNcpdpClaimOwnFinalQTRErr,
        showDefNcpdpClaimMbFinalQTRErr: showDefNcpdpClaimMbFinalQTRErr,
        showDefPrintImageFinalQtrErr: showDefPrintImageFinalQtrErr,
      });
    } else {
      const errorData = [...errorMessages];
      if (name === 'email') {
        const index = errorData.findIndex((x) => {
          return x.includes(constantMessageData.EMAIL_INVALID);
        });
        errorData.splice(index, 1);
      }
      if (name === 'zip4') {
        const index = errorData.findIndex((x) => {
          return x.includes(constantMessageData.ZIP4_REQUIRED);
        });
        errorData.splice(index, 1);
      }
      if (name === 'phoneNum') {
        const index2 = errorData.findIndex((x) => {
          return x.includes(constantMessageData.PHONE_INVALID_ERROR);
        });
        errorData.splice(index2, 1);
      }
      setErrorMessages([...new Set(errorData)]);
      addReduxDataUpdateManufacturerTab({
        ...addEditManufacturerTabData,
        disabledSaveCancelBtn: false,
        showEmailErr,
        showZip4Err,
        showPhoneErr,
        errorMessages: [...new Set(errorData)],
      });
      setShowError({
        showLabelerStartDateErr: showLabelerStartDateErr,
        showLabelerEndDateErr: showLabelerEndDateErr,
        showNameErr: showNameErr,
        showAddrErr: showAddrErr,
        showCityErr: showCityErr,
        showStateErr: showStateErr,
        showZipErr: showZipErr,
        showZip4Err: showZip4Err,
        showPhoneErr: showPhoneErr,
        showEmailErr: showEmailErr,
        showDefPaperFinalQTRErr: showDefPaperFinalQTRErr,
        showDefCmsElectFinalQTRErr: showDefCmsElectFinalQTRErr,
        showDefNcpSummaryFinalQtrErr: showDefNcpSummaryFinalQtrErr,
        showDefNcpdpClaimOwnFinalQTRErr: showDefNcpdpClaimOwnFinalQTRErr,
        showDefNcpdpClaimMbFinalQTRErr: showDefNcpdpClaimMbFinalQTRErr,
        showDefPrintImageFinalQtrErr: showDefPrintImageFinalQtrErr,
      });
    }
  };
  // add new row on click event in bank ruptcy table
  const addBankruptcyRow = () => {
    setSuccessMessage([]);
    handleTabFormDirty(false);
    addReduxDataUpdateManufacturerTab({
      ...addEditManufacturerTabData,
      disabledSaveCancelBtn: false,
    });
    handleClearFilter();
    const newObj = {
      id: uuidv4(),
      bankruptcyTypeCd: '-1',
      addEditRow: true,
      startDate: null,
      mfgBankCruptcyId: null,
      actionVal: 0,
      endDate: null,
      inclInvoiceInd: false,
      corrLinkId: null,
      addedDate: null,
      addedUserId: null,
      isAddedFromUI: null,
      isExistingRow: false,
      isEdit: false,
      bankruptcyTypeCdErr: false,
      startDateErr: false,
      endDateErr: false,
      addNewBankruptcy: true,
      ccCommentsExist: 0,
    };
    dispatch(addNewRowBankruptcy(newObj));
  };
  // click on view history icon after call function
  const getShowViewHistoryPlan = () => {
    setShowViewHistory(true);
    if (tabValue === 'three') {
      setKeyValue({
        CONTACT_SEQ_NUM: contactDetail && contactDetail.contactSeqNum,
      });
    } else if (tabValue === 'four') {
      setKeyValue({
        MFG_ID: values.mfgId ? values.mfgId : null,
        BANKRUPTCY_TYPE_CD: bankruptcyTypeCd,
        START_DT: startDt,
      });
    } else {
      setKeyValue({ MFG_ID: values.mfgId ? values.mfgId : null });
    }
  };
  // open save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // call cancel popup
  const handleSaveClose = () => {
    setOpen(false);
    setOpenCancel(false);
  };
  const handleOpenClose = () => {
    if (!open) setOpenCancel(true);
    setOpen(false);
  };
  const handelCancelClose = () => {
    setOpenCancel(false);
    setOpen(false);
  };
  // clear filter
  const handleClearFilter = () => {
    if (applyFilter) {
      childRef.current && childRef.current.clearFilters();
      setSpinnerLoader(false);
      setApplyFilter(false);
    }
  };
  // Apply Filter
  const onFilterChanged = (e) => {
    setTotalResultCount(e.api.getDisplayedRowCount());
    if (
      (e.api.getFilterModel() && Object.keys(e.api.getFilterModel())).length > 0
    ) {
      setApplyFilter(true);
      addReduxDataUpdateManufacturerTab({
        ...addEditManufacturerTabData,
        action: 'modify',
        applyFilter: true,
      });
    } else {
      setApplyFilter(false);
      addReduxDataUpdateManufacturerTab({
        ...addEditManufacturerTabData,
        applyFilter: true,
      });
    }
    const rowData = [];
    e.api.forEachNodeAfterFilter((node) => {
      rowData.push(node.data);
    });
  };
  return (
    <div data-testid="update-Manufacturer">
      <SaveCancelPopup
        open={open}
        data-testid="saveDouble"
        title="Save"
        onConfim={() => {
          masterDataSave();
        }}
        onCancel={() => {
          handleSaveClose();
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        title="Cancel"
        data-testid="resetAllFields"
        onConfim={() => {
          resetAllFields();
        }}
        onCancel={() => {
          handelCancelClose();
        }}
      />
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space pb-0">
          {!fullScreenView && (
            <>
              <Spinner load={spinnerLoader} />
              <CustomSeparator
                parent1="Maintain"
                parent2="Maintain Manufacturer"
              />
              <DisplaySuccessMessages successMessages={successMessages} />
              {errorMessages && errorMessages.length > 0 && (
                <DisplayErrorMessages
                  errorMessages={[...new Set(errorMessages)]}
                />
              )}
            </>
          )}
          {!fullScreenView && (
            <fieldset className="custom-fieldset">
              <legend className="d-none" />
              <form autoComplete="off">
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="Manufacturer_ID"
                      label="Manufacturer ID"
                      className="mandate-fields"
                      data-testid="Manufacturer-ID"
                      disabled={!createMFG}
                      fullWidth
                      required
                      placeholder=""
                      autoFocus={
                        !!(values.mfgId === '' || values.mfgId === null)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        maxLength: values.mfgTypeCd === 'G' ? 5 : 10,
                        id: 'Manufacturer_ID',
                      }}
                      value={values.mfgId}
                      onBlur={handleOnBlurEv}
                      onChange={(e) => {
                        setValues({ ...values, mfgId: e.target.value });
                        addReduxDataUpdateManufacturerTab({
                          ...addEditManufacturerTabData,
                          values: { ...values, mfgId: e.target.value },
                        });
                      }}
                      helperText={error.mfgIdError}
                      error={error.mfgIdError}
                    />
                  </div>

                  <div className="mui-custom-form input-md ellipsis-text">
                    {values.mfgName &&
                    values.mfgName !== '' &&
                    values.mfgName.length > 20 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="com-tooltip">{values.mfgName}</Tooltip>
                        }
                      >
                        <TextField
                          className="mandate-fields"
                          label="  Manufacturer Name"
                          id="Manufacturer_Name"
                          data-testid="long-text-mfg-name"
                          fullWidth
                          required
                          placeholder=""
                          disabled={
                            (values && values.mfgTypeCd) === 'G' && !createMFG
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            maxLength: 120,
                            id: 'Manufacturer_Name',
                          }}
                          value={values.mfgName}
                          onChange={(e) => {
                            setValues({ ...values, mfgName: e.target.value });
                            addReduxDataUpdateManufacturerTab({
                              ...addEditManufacturerTabData,
                              action: 'modify',
                              values: { ...values, mfgName: e.target.value },
                              manufacturerDetail: manufacturerDetail,
                              contactDetail: contactDetail,
                              tabValue: tabValue,
                            });
                          }}
                          onBlur={(e) => handleOnBlurMfgName(e)}
                          helperText={error.mfgName_Error}
                          error={error.mfgName_Error}
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        className="mandate-fields"
                        label="  Manufacturer Name"
                        id="Manufacturer_Name1"
                        data-testid="ManufacturerName"
                        fullWidth
                        required
                        placeholder=""
                        disabled={
                          (values && values.mfgTypeCd) == 'G' && !createMFG
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 120,
                          id: 'Manufacturer_Name1',
                        }}
                        value={values.mfgName}
                        onChange={(e) => {
                          setValues({ ...values, mfgName: e.target.value });
                          addReduxDataUpdateManufacturerTab({
                            ...addEditManufacturerTabData,
                            action: 'modify',
                            values: { ...values, mfgName: e.target.value },
                            manufacturerDetail: manufacturerDetail,
                            contactDetail: contactDetail,
                            tabValue: tabValue,
                          });
                        }}
                        onBlur={(e) => handleOnBlurMfgName(e)}
                        helperText={error.mfgName_Error}
                        error={error.mfgName_Error}
                      />
                    )}
                  </div>

                  <div className="mui-custom-form input-md">
                    <TextField
                      label=" Manufacturer Type"
                      id="Manufacturer_Type"
                      fullWidth
                      required
                      disabled
                      placeholder=""
                      value={
                        values && values.mfgTypeCd == 'G'
                          ? 'Governmental'
                          : 'Commercial'
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        maxLength: 10,
                        id: 'Manufacturer_Type',
                      }}
                    />
                  </div>

                  {checkActionAccessByRole(
                    process?.env?.REACT_APP_HIDE_ACCESS_ROLES,
                    kcRoles
                  ) && (
                    <div className="mui-custom-form input-md">
                      <div className="comment-sec mt-26">
                        Comments &nbsp;
                        <img
                          role="button"
                          onClick={() => {
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setShowComments(true);
                            }
                          }}
                          alt="comment"
                          src={commentShow ? CommentVisibleIcon : CommentIcon}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </fieldset>
          )}
          {!fullScreenView && (
            <div className="btn-wrapper mb-2">
              <div className="float-right mt-2 hide-on-print">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="saveBtn"
                  disabled={disabledSaveCancelBtn || !isEnablebyRole}
                  onClick={() => {
                    onSubmit(true);
                  }}
                >
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  onClick={handleOpenClose}
                  disabled={disabledSaveCancelBtn || !isEnablebyRole}
                  data-testid="cancelBtn"
                  className="btn btn-cancel btn btn-primary"
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
              <div className="clearfix" />
            </div>
          )}
          <div className="tabs-wrapper">
            <div className="float-left">
              <ManufacturerTabs
                data-testid="manufacturer-tabs"
                handleChangeTabValue={(event, newValue) => {
                  errorMessages &&
                    errorMessages.length > 0 &&
                    errorMessages.forEach((x, key) => {
                      if (
                        x ===
                        constantMessageData.MFG_NO_CONTRACT_USING_CONTACT_ERROR
                      ) {
                        return (
                          errorMessages.splice(key, 1),
                          setErrorMessages([...new Set(errorMessages)]),
                          addReduxDataUpdateManufacturerTab({
                            ...addEditManufacturerTabData,
                            action: 'modify',
                            errorMessages: [...new Set(errorMessages)],
                          })
                        );
                      }
                    });
                  if (newValue === 'one') {
                    setExportFileName('Manufacturer-Labelers');
                  } else if (newValue === 'four') {
                    setExportFileName('Manufacturer-Bankruptcy');
                  } else if (newValue === 'five') {
                    setExportFileName('Manufacturer-Contracts');
                  }
                  setTabValue(newValue);
                  addReduxDataUpdateManufacturerTab({
                    ...addEditManufacturerTabData,
                    action: 'modify',
                    tabValue: newValue,
                    disabledSaveCancelBtn: disabledSaveCancelBtn,
                    values: values,
                    manufacturerDetail: manufacturerDetail,
                    contactDetail: contactDetail,
                    errorMessages: errorMessages,
                  });
                  handleClearFilter();
                }}
                CreateManufacturer={!!createMFG}
                errorMessagesArray={errorMessages}
                labelersTabError={
                  !!(showLabelerStartDateErr || showLabelerEndDateErr)
                }
                contactTabError={
                  !!(
                    showNameErr ||
                    showAddrErr ||
                    showCityErr ||
                    showStateErr ||
                    showZipErr ||
                    showPhoneErr
                  )
                }
                manufacturerDetailTabError={
                  !!(
                    showDefPaperFinalQTRErr ||
                    showDefCmsElectFinalQTRErr ||
                    showDefNcpSummaryFinalQtrErr ||
                    showDefNcpdpClaimOwnFinalQTRErr ||
                    showDefNcpdpClaimMbFinalQTRErr ||
                    showDefPrintImageFinalQtrErr
                  )
                }
                bankruptcyTabError={
                  !!(
                    showBankruptcyTypeCdErr ||
                    showBankruptcyStartDateErr ||
                    showBankruptcyEndDateErr ||
                    showBankruptcyOverlappingErr
                  )
                }
                tabValue={tabValue}
              />
            </div>
            <div className="float-right mt-2">
              <div className="panel-header">
                <div className="float-left btn-plus mt-1 mr-5">
                  {!isEnablebyRole ||
                    (tabValue === 'four' &&
                      checkActionAccessByRole(
                        process.env.REACT_APP_HIDE_ACCESS_ROLES,
                        kcRoles
                      ) && (
                        <Link
                          to="#"
                          className="icon-plus float-center"
                          data-testid="add-bankckrupty"
                          role="button"
                          onClick={addBankruptcyRow}
                        >
                          <span>Bankruptcy Period</span>
                        </Link>
                      ))}
                </div>
                <div className="float-right th-icon-group mt-2">
                  {tabValue === 'two' || tabValue === 'three' ? null : (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="filter-tooltip">Reset All Filters</Tooltip>
                      }
                    >
                      {applyFilter ? (
                        <div
                          className="th-icon ic-filter-activate"
                          data-testid="handleClearFilter"
                          role="button"
                          onClick={handleClearFilter}
                        >
                          <span className="ic-title"> Filter </span>{' '}
                        </div>
                      ) : (
                        <div className="th-icon ic-filter">
                          <span className="ic-title"> Filter </span>{' '}
                        </div>
                      )}
                    </OverlayTrigger>
                  )}
                  {tabValue === 'one' ||
                  tabValue === 'five' ? null : !createMFG ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="history-tooltip">View History</Tooltip>
                      }
                    >
                      <div
                        className="th-icon ic-history"
                        role="button"
                        onClick={getShowViewHistoryPlan}
                        data-testid="getShowViewHistoryPlan"
                        tabIndex="0"
                      >
                        <span className="ic-title"> History </span>
                      </div>
                    </OverlayTrigger>
                  ) : null}
                  {tabValue === 'two' || tabValue === 'three' ? null : (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="history-tooltip"> Actions </Tooltip>
                      }
                    >
                      <div className="th-icon ic-actions">
                        {' '}
                        <PDFExportPanel
                          gridApi={gridApi}
                          columnApi={columnApi}
                          fileName={exportFileName}
                          childRef={childRef}
                        />
                      </div>
                    </OverlayTrigger>
                  )}
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="fullScreen-tooltip">
                        {fullScreenView ? 'Minimize Screen' : 'Full Screen'}{' '}
                      </Tooltip>
                    }
                  >
                    <div
                      className={
                        fullScreenView
                          ? 'th-icon ic-fulScreen-exit'
                          : 'th-icon ic-fulScreen'
                      }
                      role="button"
                      tabIndex="0"
                      data-testid="setFullScreenView"
                      onClick={() => {
                        setFullScreenView(!fullScreenView);
                        addReduxDataUpdateManufacturerTab({
                          ...addEditManufacturerTabData,
                          fullScreenView: !fullScreenView,
                          values: values,
                          manufacturerDetail: manufacturerDetail,
                          contactDetail: contactDetail,
                        });
                      }}
                    >
                      <span className="ic-title">
                        {' '}
                        {fullScreenView
                          ? 'Minimize Screen'
                          : 'Full Screen'}{' '}
                      </span>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            <div className="clearfix" />
          </div>
          <div className="tabs-body">
            {tabValue === 'one' && (
              <ManufacturerLabelers
                childRef={childRef}
                setSuccessMessage={setSuccessMessage}
                setErrorMessages={setErrorMessages}
                setDisabledSaveCancelBtn={handleTabFormDirty}
                addEditReduxDataManufacturerTab={
                  addReduxDataUpdateManufacturerTab
                }
                addEditManufacturerTabData={addEditManufacturerTabData}
                totalResultCount={totalResultCount}
                setTotalResultCount={setTotalResultCount}
                disabledSaveCancelBtn={disabledSaveCancelBtn}
                manufacturerDetail={manufacturerDetail}
                contactDetail={contactDetail}
                values={values}
                errorMessages={
                  Array.isArray(errorMessages) ? errorMessages : []
                }
                cellHead={CommercialLabelerHead}
                fullScreenView={fullScreenView}
                selectMFGData={selectMFGData}
                showLabelerStartDateErr={showLabelerStartDateErr}
                showLabelerEndDateErr={showLabelerEndDateErr}
                data={labelerRowData}
                applyFilter={applyFilter}
                setColumnApi={setColumnApi}
                setGridApi={setGridApi}
                onFilterChanged={onFilterChanged}
                createMFG={!!createMFG}
                permanentDeleteLabelerList={permanentDeleteLabelerList}
                setPermanentDeleteLabelerList={setPermanentDeleteLabelerList}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {tabValue === 'two' && (
              <ManufacturerDetails
                childRef={childRef}
                setSuccessMessage={setSuccessMessage}
                setErrorMessages={setErrorMessages}
                setDisabledSaveCancelBtn={handleTabFormDirty}
                addEditReduxDataManufacturerTab={
                  addReduxDataUpdateManufacturerTab
                }
                addEditManufacturerTabData={addEditManufacturerTabData}
                disabledSaveCancelBtn={disabledSaveCancelBtn}
                errorMessages={
                  Array.isArray(errorMessages) ? errorMessages : []
                }
                manufacturerDetail={manufacturerDetail}
                fullScreenView={fullScreenView}
                setManufacturerDetail={setManufacturerDetail}
                showDefPaperFinalQTRErr={showDefPaperFinalQTRErr}
                showDefCmsElectFinalQTRErr={showDefCmsElectFinalQTRErr}
                showDefNcpSummaryFinalQtrErr={showDefNcpSummaryFinalQtrErr}
                showDefNcpdpClaimMbFinalQTRErr={showDefNcpdpClaimMbFinalQTRErr}
                showDefPrintImageFinalQtrErr={showDefPrintImageFinalQtrErr}
                showDefNcpdpClaimOwnFinalQTRErr={
                  showDefNcpdpClaimOwnFinalQTRErr
                }
                commonDropdownList={commonDropdownList}
                isEnablebyRole={isEnablebyRole}
              />
            )}

            {tabValue === 'three' && (
              <ManufacturerContact
                data-testid="handleOnBlurEventContactTab"
                childRef={childRef}
                setSuccessMessage={setSuccessMessage}
                setErrorMessages={setErrorMessages}
                setDisabledSaveCancelBtn={handleTabFormDirty}
                setCallContactDetailApi={setCallContactDetailApi}
                addEditReduxDataManufacturerTab={
                  addReduxDataUpdateManufacturerTab
                }
                addEditManufacturerTabData={addEditManufacturerTabData}
                callContactDetailApi={callContactDetailApi}
                disabledSaveCancelBtn={disabledSaveCancelBtn}
                setSpinnerLoader={setSpinnerLoader}
                CreateManufacturer={!!createMFG}
                errorMessages={
                  Array.isArray(errorMessages) ? errorMessages : []
                }
                contactDetail={contactDetail}
                fullScreenView={fullScreenView}
                contractListRowData={contractListRowData}
                setContactDetail={setContactDetail}
                resetContactBaseline={resetContactBaseline}
                selectMFGData={selectMFGData}
                setShowError={setShowError}
                onFilterChanged={onFilterChanged}
                handleOnBlurEvent={(e, name) => {
                  handleOnBlurEventContactTab(e, name);
                }}
                showNameErr={showNameErr}
                showAddrErr={showAddrErr}
                showCityErr={showCityErr}
                showStateErr={showStateErr}
                showZipErr={showZipErr}
                showZip4Err={showZip4Err}
                showPhoneErr={showPhoneErr}
                showEmailErr={showEmailErr}
                commonDropdownList={commonDropdownList}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {tabValue === 'four' && (
              <ManufacturerBankruptcy
                childRef={childRef}
                setSuccessMessage={setSuccessMessage}
                setErrorMessages={setErrorMessages}
                setDisabledSaveCancelBtn={handleTabFormDirty}
                addEditReduxDataManufacturerTab={
                  addReduxDataUpdateManufacturerTab
                }
                addEditManufacturerTabData={addEditManufacturerTabData}
                disabledSaveCancelBtn={disabledSaveCancelBtn}
                totalResultCount={totalResultCount}
                values={values}
                setTotalResultCount={setTotalResultCount}
                setBankruptcyTypeCd={setBankruptcyTypeCd}
                setStartDt={setStartDt}
                errorMessages={
                  Array.isArray(errorMessages) ? errorMessages : []
                }
                fullScreenView={fullScreenView}
                showBankruptcyTypeCdErr={showBankruptcyTypeCdErr}
                showBankruptcyStartDateErr={showBankruptcyStartDateErr}
                showBankruptcyEndDateErr={showBankruptcyEndDateErr}
                cellHead={BankruptcyHead}
                addBankruptcyRow={addBankruptcyRow}
                data={bankruptcyRowData}
                setPermanentDeleteLaBankruptcyList={
                  setPermanentDeleteLaBankruptcyList
                }
                permanentDeleteLaBankruptcyList={
                  permanentDeleteLaBankruptcyList
                }
                onFilterChanged={onFilterChanged}
                setColumnApi={setColumnApi}
                setGridApi={setGridApi}
                createMFG={!!createMFG}
                commonDropdownList={commonDropdownList}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {tabValue === 'five' && (
              <ManufacturerContracts
                childRef={childRef}
                totalResultCount={totalResultCount}
                setTotalResultCount={setTotalResultCount}
                addEditReduxDataManufacturerTab={
                  addReduxDataUpdateManufacturerTab
                }
                addEditManufacturerTabData={addEditManufacturerTabData}
                data={
                  contractListRowData &&
                  contractListRowData.length > 0 &&
                  contractListRowData.map((item) => {
                    item.endDt =
                      item.endDt !== null
                        ? moment(item.endDt).format('MM/DD/yyyy')
                        : null;
                    item.startDt = item.startDt;
                    return item;
                  })
                }
                cellHead={contractsHead}
                fullScreenView={fullScreenView}
                setDisabledSaveCancelBtn={handleTabFormDirty}
                disabledSaveCancelBtn={disabledSaveCancelBtn}
                onFilterChanged={onFilterChanged}
                setColumnApi={setColumnApi}
                setGridApi={setGridApi}
              />
            )}
          </div>
        </div>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName={
            tabValue === 'four'
              ? 'MFG_BANKRUPTCY'
              : tabValue === 'three'
              ? 'CONTACT'
              : 'MFG'
          }
          keyValue={keyValue}
          isSpinner
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="MFG"
          corrLinkId={values && values.corrLinkId}
          rowGridPrimaryKey={values && values.mfgId}
        />
      ) : null}
    </div>
  );
}